import { createFileRoute } from '@tanstack/react-router';

import { PerformancePage } from '@/features/(insight)/performance/index';

export const Route = createFileRoute('/workspace/$workspaceId/insight/performance')({
  component: PerformancePage,
});
